import { render } from "./ViewBonAncienPage.vue?vue&type=template&id=32a2de72&ts=true"
import script from "./ViewBonAncienPage.vue?vue&type=script&lang=ts"
export * from "./ViewBonAncienPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__